/*
 * 头部消息
 * author: v_xmdjliu
 * time: 2019-03-25
 */
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { Tabs, TabPanel } from '@tencent/spaui';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import _ from 'lodash';
import './SelectionDataComponent.scoped.less';
import Announcement from './Announcement';
import Notify from './Notify';
import { autorun } from 'mobx';
import { withAccount } from '@/business-components/operator/account-context.js';
import noticeService from '../services/notice';
import messageService from './services/index';
import messageStore from './store/index';
import noticeStore from '../store/index';

// 收件箱
@observer
class MsgNotify extends PureComponent {
  componentDidMount() {
    const { className = 'msgNotify', account } = this.props;
    noticeService.getUnreadedCount();
  }

  render() {
    const { className = 'msgNotify', account } = this.props;
    const { notifyData } = messageStore.messageNotifyStore;
    const notifyUnread = _.reduce(notifyData.summary?.slice() || [], (item, n) => item + n.unread, 0);
    const hasUnRead = noticeStore.unreadCount + notifyUnread > 0;
    return (
      <li className={`${className} spaui-topnav-drop inbox-card-drop `}>
        <a className={classnames('nav-button', hasUnRead ? 'with-indicator' : '')} href="javascript:;">
          <i className="spaui-icon icon-nav-inbox" />
        </a>
        <div className="spaui-topnav-menu inbox-card notify-card">
          <Tabs onChange={(e, value) => messageService.handleTabsChange(value)} value={messageStore.tabsValue} needSlider={false}>
          <TabPanel tab="公告" name={1} data-report-global="notify-notice">
            <Announcement {...this.props} />
          </TabPanel>
            <TabPanel tab="通知" name={2} data-report-global="notify-message">
              <Notify {...this.props} />
            </TabPanel>
          </Tabs>
          <Link to={'/agency/notice'} className="notify-center" data-report-global="jump-to-notice-center">
            公告中心
          </Link>
        </div>
      </li>
    );
  }
}

export default withAccount(MsgNotify);
